
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class CompareModal extends Vue {

  public closeModal() {
    this.$store.commit('setModal', '');
  }

}

